export const fieldsCollaboratorTable = [
  {
    key: 'name',
    label: 'Collaborator Name',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'package',
    label: 'Package',
    thClass: 'font-bold capitalize text-black',
    tdClass: 'px-0 d-flex justify-content-center',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '150px',
    },
  },
  {
    key: 'phone_number',
    label: 'Phone Number',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'address',
    label: 'Address',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'api_access',
    label: 'API Access',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'detail',
    label: '',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]

export const fieldExpeditionService = [
  {
    key: 'shipping_name',
    label: 'Expedition',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'regular',
    label: 'Regular',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'cargo',
    label: 'Cargo',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'lite',
    label: 'Lite',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'flat',
    label: 'Flat',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'instant',
    label: 'instant',
    thClass: 'font-bold text-black',
    class: 'align-middle text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
]

export const fieldsRequestDoc = [
  {
    key: 'name',
    label: 'Collaborator Name',
    thClass: 'font-bold capitalize text-black',
    tdClass: 'p-1',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'service',
    label: 'Service',
    thClass: 'font-bold text-black',
    tdClass: 'pl-1 py-1',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'status',
    label: 'Current Status',
    thClass: 'font-bold capitalize text-black',
    tdClass: 'pl-1 py-1',
    class: 'align-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'sla',
    label: 'SLA',
    thClass: 'font-bold text-black',
    tdClass: 'p-lg-1 p-0',
    class: 'align-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'ca',
    label: 'CA',
    thClass: 'font-bold text-black',
    tdClass: 'p-lg-1 p-0',
    class: 'align-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'uat',
    label: 'UAT',
    thClass: 'font-bold text-black',
    tdClass: 'p-lg-1 p-0',
    class: 'align-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'detail',
    label: 'Action',
    thClass: 'font-bold text-black',
    class: 'align-center text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]
export const mainColsUserTracker = [
  { label: 'Collaborator Info', rowspan: 2, class: '' },
  { label: 'Service', rowspan: 2, class: '' },
  { label: 'Current Status', rowspan: 2, class: '' },
  { label: 'Review in Progress', colspan: 3, class: 'text-center w-[300px]' },
  { label: '', rowspan: 2, class: '' },
]

export const subColsUserTracker = ['SLA', 'CA', 'UAT']
export const fieldSLATab = [
  {
    key: 'name',
    label: '',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'document',
    label: 'Document',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'notes',
    label: 'Notes',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]
export const fieldUAT = [
  {
    key: 'name',
    label: 'Name',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '200px',
    },
  },
  {
    key: 'input',
    label: 'Input',
    thClass: 'font-bold text-black',
    tdClass: 'font-italic',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'expect_result',
    label: 'Expect Result',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'curl',
    label: 'cURL',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
  {
    key: 'result',
    label: 'Result',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '200px',
    },
  },
  {
    key: 'note',
    label: 'Note',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
      width: '250px',
    },
  },
]

export const fieldHistoryUser = [
  {
    key: 'status',
    label: 'Status',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'created_at',
    label: 'Date',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    sortable: true,
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'expired_date',
    label: 'Active Until',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'package',
    label: 'Membership Package',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
  {
    key: 'amount',
    label: 'Payment',
    thClass: 'font-bold text-black',
    class: 'align-top text-black',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      fontWeight: 600,
    },
  },
]

export const listSLAFiles = [
  {
    key: 'sla_file',
    list: 'Service Agreement signed by the client',
    sub: '',
    required: true,
  },
  {
    key: 'amandement_business_file',
    list: 'Deed of Establishment and the most recent Amendment of the Business Entity',
    sub: '',
    required: true,
  },
  {
    key: 'npwp_file',
    list: 'Business Taxpayer Identification Number (NPWP) / Personal NPWP of the Company Owner',
    sub: '',
    required: false,
  },
  {
    key: 'nib_file',
    list: 'Business Identification Number (NIB) / Business License',
    sub: '(for Business Entity Agreements)',
    required: false,
  },
  {
    key: 'bank_account_number_file',
    list: 'Business Entity Bank Account Number / Copy of Bank Account Statement',
    sub: '',
    required: true,
  },
  {
    key: 'id_card_file',
    list: 'ID card (KTP) of the Director / Representative in charge of signing',
    sub: '',
    required: true,
  },
  {
    key: 'power_of_attorney_file',
    list: 'Power of Attorney',
    sub: '(for Directors unable to sign)',
    required: false,
  },
  {
    key: 'statement_letter_file',
    list: 'Statement Letter for Non-Business Entity Bank Accounts',
    sub: '',
    required: false,
  },
  {
    key: 'pic_dashboard',
    list: 'ID card (KTP) of the PIC for the Dashboard / API account',
    sub: '',
    required: false,
  },
]

export const listPaymentFiles = [
  {
    key: 'sla_file',
    list: 'Service Agreement signed by the client',
    sub: '',
    required: true,
  },
  {
    key: 'amandement_business_file',
    list: 'Deed of Establishment and the most recent Amendment of the Business Entity',
    sub: '',
    required: true,
  },
  {
    key: 'npwp_file',
    list: 'Business Taxpayer Identification Number (NPWP) / Personal NPWP of the Company Owner',
    sub: '',
    required: false,
  },
  {
    key: 'nib_file',
    list: 'Business Identification Number (NIB) / Business License',
    sub: '(for Business Entity Agreements)',
    required: false,
  },
  {
    key: 'bank_account_number_file',
    list: 'Business Entity Bank Account Number / Copy of Bank Account Statement',
    sub: '',
    required: true,
  },
  {
    key: 'id_card_file',
    list: 'ID card (KTP) of the Director / Representative in charge of signing',
    sub: '',
    required: true,
  },
  {
    key: 'power_of_attorney_file',
    list: 'Power of Attorney',
    sub: '(for Directors unable to sign)',
    required: false,
  },
  {
    key: 'statement_letter_file',
    list: 'Statement Letter for Non-Business Entity Bank Accounts',
    sub: '',
    required: false,
  },
  {
    key: 'pic_dashboard',
    list: 'ID card (KTP) of the PIC for the Dashboard / API account',
    sub: '',
    required: false,
  },
]

export const listQrislyFiles = [
  {
    key: 'sla_file',
    list: 'Service Agreement signed by the client',
    sub: '',
    required: true,
  },
  {
    key: 'bank_account_number_file',
    list: 'Business Entity Bank Account Number / Copy of Bank Account Statement',
    sub: '',
    required: true,
  },
  {
    key: 'id_card_file',
    list: 'ID card (KTP) of the Director / Representative in charge of signing',
    sub: '',
    required: true,
  },
]

export const analytics = [
  {
    icon: 'https://storage.googleapis.com/komerce/assets/icons/profile-2user-blue.svg', classIcon: 'bg-[#BEE6FC]', title: 'User Register', value: 'registered_user', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/icons/profile-tick-green.svg', classIcon: 'bg-[#DCF3EB]', title: 'User Verify', value: 'verified_user', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/presention-chart.svg', classIcon: 'bg-[#E2E2E2]', title: 'Retention', value: 'retention_user', countTitle: 'Last Month', percenTitle: 'This Month',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/user-yellow.svg', classIcon: 'bg-[#FEF2CD]', title: 'User Active', value: 'user_active', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/archive.svg', classIcon: 'bg-[#FCD4BE]', title: 'Order Store', value: 'total_order', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/icons/truck-tick-yellow.svg', classIcon: 'bg-[#FFF2E2]', title: 'Pickup', value: 'request_pickup', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/box-tick-green.svg', classIcon: 'bg-[#D6EEDD]', title: 'Delivered', value: 'order_received', countTitle: 'Last Week', percenTitle: 'This Week',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/assets/icons/danger-red.svg', classIcon: 'bg-[#FFEDED]', title: 'Problem', value: 'order_problem', countTitle: 'Last Week', percenTitle: 'This Week',
  },
]

export const chartOptions = {
  series: [],
  resetSeries: {
    shouldUpdateChart: true,
  },
  dataLabels: {
    enabled: false,
  },
  colors: ['#F95031', '#FBBC05'],
  chart: {
    stacked: true,
    stackType: '100%',
    type: 'bar',
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      borderRadius: 8,
      borderRadiusApplication: 'around',
      borderRadiusWhenStacked: 'last',
    },
  },
  xaxis: {
    labels: { show: false },
    axisTicks: { show: false },
    axisBorder: { show: false },
  },
  yaxis: {
    show: false,
    axisTicks: { show: false },
    axisBorder: { show: false },
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'left',
    itemMargin: {
      horizontal: 20,
      vertical: 0,
    },
  },
  fill: {
    opacity: 1,
  },
  grid: {
    show: false,
  },
  tooltip: {
    shared: false,
    fixed: {
      enabled: false,
      position: 'top',
      offsetX: 10,
      offsetY: 8,
    },
    custom({ series, seriesIndex, w }) {
      const { color } = w.globals.initialSeries[seriesIndex]
      const { name } = w.globals.initialSeries[seriesIndex]
      const value = series[seriesIndex]
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')

      return `
      <div class="-top-5">
      <div class="px-1 py-75 flex flex-column"
           style="
             width: 150px;
             border-radius: 8px;
             background: white;
           ">
        <div class="flex items-center gap-3">
          <div style="width: 10px; height: 10px; border-radius: 50%; background-color: ${color};"></div>
          <small>${name}</small>
        </div>
        <span class="font-bold text-[16px] text-black mt-1">${value}</span>
      </div>
        <div style="
        position: absolute;
        bottom: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #F95031;
      "></div>
      </div>
      `
    },
  },
}

export const listSummary = [
  {
    title: 'Total User',
    value: 0,
    icon: 'https://storage.googleapis.com/komerce/assets/icons/profile-2user-blue.svg',
    color: 'bg-[#BEE6FC]',
  },
  {
    title: 'Submitted',
    value: 0,
    icon: 'https://storage.googleapis.com/komerce/assets/folder-add.png',
    color: 'bg-[#FEF2CD]',
  },
  {
    title: 'Need Revision',
    value: 0,
    icon: 'https://storage.googleapis.com/komerce/assets/icons/danger-red.svg',
    color: 'bg-[#FFEDED]',
  },
  {
    title: 'Live',
    value: 0,
    icon: 'https://storage.googleapis.com/komerce/assets/icons/clipboard-tick.svg',
    color: 'bg-[#D6EEDD]',
  },
]

export const fieldListUpdateLog = [
  {
    key: 'checkbox',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      maxWidth: '80px',
    },
    thClass: 'pr-0 pl-0',
    tdClass: 'pr-0 pl-0',
  },
  {
    key: 'no',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      maxWidth: '80px',
    },
    tdClass: 'text-black w-[80px]',
    class: '',
  },
  {
    key: 'title',
    label: 'Judul',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'status',
    label: 'Status',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    class: 'p-1',
  },
  {
    key: 'action',
    label: 'Aksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
    },
    tdClass: 'text-start min-w-[110px]',
    class: 'p-1',
    formatter: value => (value === 1 ? 'Aktif' : 'Non Aktif'),
  },
]
